import * as iconoir from "@attaditya/iconoir-preact/regular";

export const LATEST: {
  icon: keyof typeof iconoir;
  title: string;
  url: string;
}[] = [
  {
    icon: "LaptopDevModeRegular",
    url: "https://bashbrunch.attaditya.space/",
    title: "BashBrunch",
  },
  {
    icon: "SparksRegular",
    url: "https://cutycode.attaditya.space/",
    title: "CutyCode",
  },
  {
    icon: "PuzzleRegular",
    url: "https://pypi.org/project/gsam",
    title: "GSAM",
  },
];

